module.exports = __webpack_public_path__ + "static/media/cnc.579e8279.jpg";